import React, {useContext} from "react";
import FilterEventContext from "/context/filter/FilterContext";
import CardItem from "./CardItem";

export default function Cards({children, productions}) {
    const {state: {filtered}} = useContext(FilterEventContext);
    const scroll = 'scrollbar-thin scrollbar-thumb-gold overflow-y-scroll scrollbar-thumb-rounded-full scrollbar-track-rounded-full';
    return (
        <div className={`flex flex-1 justify-center overflow-scroll ${scroll} bg-white m-2`}>
            <div
                className={`flex flex-wrap max-w-[1200px] justify-center lg:justify-start px-16 mt-4`}>
                {
                    productions?.map((event, index) => {
                        return (
                            <CardItem
                                key={event.slug}
                                event={event}
                            >
                            </CardItem>
                        );
                    })
                }
                <div className="h-24 w-full"></div>
            </div>
        </div>
    );
}
